import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { authSelector } from "../../features/auth/authSlice";


const RequireAdmin = ({children}) => {
  const { isAuth, user } = useSelector(authSelector);

  let location = useLocation();

  if (!isAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user?.roles?.includes('biotech-supervision-admin')) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
} 

export default RequireAdmin;
